module.exports = __webpack_public_path__ + "img/donante-el-sazon.682f80ad.jpeg";